<template>
    <div class="card" v-bind:class="question.type">
        <div class="card-header" :id="'header-'+step+'Question'+question.id" data-toggle="collapse"
             :data-target="'#collapseStep'+step+'Question'+question.id"
             v-bind:aria-expanded="question.openByDefault ? 'true' : 'false'"
             aria-controls="collapseOne"
             :class="{'answered' : showSpoiler}"
        >
            <h5 class="mb-0">
                <button class="btn btn-link">
                    {{question.label}}
                </button>
                <div class="recap" v-show="showSpoiler">
                    <ul>
                        <li v-for="(answer, answerIndex) in question.answers">{{form_values[answerIndex]}}
                        </li>
                    </ul>
                </div>
            </h5>
        </div>

        <div :id="'collapseStep'+step+'Question'+question.id" class="collapse"
             v-bind:class="{show : question.openByDefault}"
             :aria-labelledby="'collapseStep'+step+'Question'+question.id" data-parent="#main-form">
            <div v-if="question.extraHtml !== undefined && question.extraHtml.content_top !== null !== undefined && question.extraHtml.content_top !== null"
                 v-html="question.extraHtml.content_top"></div>

            <div class="card-body">
                <div v-for="(answer, answerIndex) in question.answers" class="checkbox-choice">
                    <label :class="{full: form_values[answerIndex]}">
                        <span v-if="showMinMax(answer)" v-html="generateMinMax(answer)"></span>

                        <span v-else-if="showMinMax(answer) || getMinMax(answer, 'max') !== undefined">
                            {{answer.label}}<br>
                            Min : {{getMinMax(answer, 'min')}} mm - Max : {{getMinMax(answer, 'max')}} mm
                        </span>
                        <span v-else>
                            {{answer.label}}<br>
                            <span>&nbsp;</span>
                        </span>
                        <input :type="answer.type"
                               :min="getMinMax(answer, 'min')"
                               :max="getMinMax(answer, 'max')"
                               v-bind:class="{'not-valid': !isValid(form_values[answerIndex], getMinMax(answer))}"

                               @keyup="addToAnswers(answerIndex, answer.variable, answer)"
                               v-model="form_values[answerIndex]"
                               :placeholder="answer.label"
                        >
                    </label>
                </div>
            </div>
            <div v-if="question.extraHtml !== undefined && question.extraHtml.content_bottom !== null !== undefined && question.extraHtml.content_bottom !== null"
                 v-html="question.extraHtml.content_bottom"></div>

            <!-- Button trigger modal -->

            <button v-if="question.popup !== undefined && question.popup !== ''" type="button" class="open-modal"
                    data-toggle="modal" @click="fillAndOpenDefaultModal()">
                {{question.popupLabel}}
            </button>
            <!-- Modal -->

        </div>

    </div>

</template>

<script>
    import common from './mixins/common'
    import Vue from 'vue'

    export default {
        name: "MultipleInputsBasic",

        props: {
            question: Object || Array,
            questions: Object || Array,
            step: [String, Number],
        },

        mixins: [common],

        data: function () {
            return {
                form_values: [],
                showSpoiler: false
            }
        },
        watch: {

            form_values: function (newVal) {
                let keepOld = false;

                const oldVal = newVal.map((el, index) => {
                    if (this.checkIfTooLong(this.question.answers[index], el))
                        return el.toString().slice(0, -1);
                    return el

                });

                if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
                    Vue.set(this, 'form_values', oldVal)

            }
        },
        methods: {
            checkIfTooLong(answer, value) {
                let variable;
                switch (answer.variable) {
                    case 'hauteur' :
                        variable = 'height';
                        break;
                    case 'largeur' :
                        variable = 'width';
                        break;
                    default :
                        variable = answer.variable
                }
                if (this.$store.state.heightWidthConstraint[variable] !== undefined) {
                    if (value > this.$store.state.heightWidthConstraint[variable].max) {
                        return true
                    }
                }
                return false;
            },
            fillAndOpenDefaultModal() {
                let modal = $('#basicModal');
                modal.find('h5').text(this.question.popupLabel);
                modal.find('img').attr('src', this.question.popup);
                modal.find('.extra-popup').html('')
                modal.modal('show');

            },

            /*onFocus(answerIndex, modifier, answer){
                if (this.form_values[answerIndex] !== ""){
                    this.addToAnswers(answerIndex, modifier, answer);
                }
            },*/
            showMinMax(question) {
                return question.variable === "hauteur" || question.variable === "largeur"
            },
            getMinMax(answer, type) {
                let variable = "";
                switch (answer.variable) {
                    case 'hauteur' :
                        variable = 'height';
                        break;
                    case 'largeur' :
                        variable = 'width';
                        break;
                    default :
                        variable = answer.variable
                }

                if (answer[type] !== undefined) {
                    return answer[type];
                }
                if (type !== undefined) {
                    if (this.$store.state.heightWidthConstraint[variable] !== undefined)
                        return this.$store.state.heightWidthConstraint[variable][type];
                } else {
                    if (answer.min !== undefined) {
                        return {min: answer.min, max: answer.max};
                    }
                    return this.$store.state.heightWidthConstraint[variable]
                }
            },
            isValid(value, minMax) {
                if (value)
                    return value === undefined || minMax === undefined || (value >= parseInt(minMax.min) && value <= parseInt(minMax.max))
            },
            generateMinMax(question) {

                return question.label + '<br> Min : ' + this.$store.state.heightWidthConstraint[question.variable === "hauteur" ? 'height' : 'width'].min + ' mm  -  Max : ' + this.$store.state.heightWidthConstraint[question.variable === "hauteur" ? 'height' : 'width'].max + ' mm';
            },


            addToAnswers: function (answerIndex, modifier, answer) {
                const questionIndex = this.question.id;
                if (this.isValid(this.form_values[answerIndex], this.getMinMax(answer))) {
                    this.$store.dispatch('setPreventNextButton', false);
                    this.questions[questionIndex].answers[answerIndex].value = this.form_values[answerIndex];
                    this.$store.dispatch('addAnswersThenCalc', {
                        isGlobal: this.question.global !== undefined && this.question.global,

                        stepIndex: this.step,
                        questionIndex: questionIndex,
                        questionType: this.questions[questionIndex].type,
                        effectOnSvg: this.questions[questionIndex].effectOnSvg,
                        index: answerIndex,
                        value: this.form_values[answerIndex],
                        variable: this.questions[questionIndex].answers[answerIndex].variable || null,
                        modifier: modifier !== undefined ? modifier : null,
                        changes: answer.changes !== undefined ? answer.changes : null,
                        name: this.form_values[answerIndex] !== undefined ? this.form_values[answerIndex].toString() : "",
                        label: this.questions[questionIndex].answers[answerIndex].label || null,

                    });

                    let isNotEmpty = true;

                    Object.keys(this.question.answers).forEach((key) => {
                        if (isNotEmpty && (this.form_values[key] === undefined || this.form_values[key] === "")) {
                            isNotEmpty = false;
                        }
                    });
                    this.showSpoiler = isNotEmpty;
                } else {
                    this.$store.dispatch('setPreventNextButton', true);
                }
            },

            initialize() {
                if (this.answers[this.step] && this.answers[this.step][this.question.id]) {
                    const formValues = this.form_values;

                    Object.keys(this.answers[this.step][this.question.id]).forEach((idx) => {
                        formValues[idx] = this.answers[this.step][this.question.id][idx].value || formValues[idx];
                    });
                    this.showSpoiler = formValues.filter((formValue) => formValue).length === formValues.length;
                }
            }
        }
    }
</script>
<style scoped>

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type='number'] {
        -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    .open-modal {
        margin-bottom: 20px;
        padding: 12px;
        /* background: #c4c4c4 !important; */
        color: #2d2d2d;
    }

    ul {
        list-style-type: none;
    }

    li {
        display: inline-block;
    }

    li:not(:last-child) {
        margin-right: 5px;
    }

    li:not(:last-child)::after {
        content: "|"
    }

    input.not-valid {
        -webkit-box-shadow: 0px 0px 0.1px 1px rgba(209, 31, 31, 1);
        -moz-box-shadow: 0px 0px 0.1px 1px rgba(209, 31, 31, 1);
        box-shadow: 0px 0px 0.1px 1px rgba(209, 31, 31, 1) !important;
    }

    input {
        font-size: 13px;
        outline: none;
    }

    input:focus {
        -webkit-box-shadow: 0px 0px 0.1px 1px rgba(51, 204, 51, 1);
        -moz-box-shadow: 0px 0px 0.1px 1px rgba(51, 204, 51, 1);
        box-shadow: 0px 0px 0.1px 1px rgba(51, 204, 51, 1);
    }

    @media screen and (max-width: 600px) {
        .modal-img {
            max-width: 100%;
            height: auto;
        }
    }
</style>
